import { IsString, IsOptional } from 'class-validator';
import { SourceTypeDto } from './source-type.interface';

export class UpdateSourceDto<T extends SourceTypeDto = SourceTypeDto> {
    @IsString()
    @IsOptional()
    name?: string;

    @IsOptional()
    config?: T['config'];

    @IsOptional()
    settings?: any;

    constructor(iUpdateSourceDto: UpdateSourceDto<T>) {
        this.name = iUpdateSourceDto.name;
        this.config = iUpdateSourceDto.config;
        this.settings = iUpdateSourceDto.settings;
    }
}
